import * as Config from '../../../../../config';
import { useState, useEffect } from "react";
import { useSelector } from 'react-redux';

import useCallbackPlay from '../../../../../hooks/useCallbackPlay';
import usePreviewPlayer from '../../../../../hooks/usePreviewPlayer';
import useTracksToPlaylist from '../../../../../hooks/useTracksToPlaylist';
import useRowAction from './useRowAction';
import useRestrictionTrack from '../../../custom/-APP_TARGET/hooks/useRestrictionTrack';
import useAutomixLoad from '../../../automix/hooks/useAutomixLoad';
import useCart from '../../../cart/hooks/useCart';

const useTrackAccess = (item, idParent, index, removeItem = null, enableActionsAutomix = true, showCart = true) => {
  const [isEnabled, setEnabled] = useState(true);
  const isProPlus = useSelector( state => state.isProPlus );
  useEffect(() => {
    if (Config.MOD_PRO) {
      if (isProPlus || (!item.is_dj_edit && !item.is_dj_remix && !isProPlus)) {
        setEnabled(true);
      } else if ((item.is_dj_edit || item.is_dj_remix) && !isProPlus) {
        setEnabled(false);
      }
    } else {
      setEnabled(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isProPlus]);
  const isRestricted = useRestrictionTrack(item, isEnabled);
  const isDisabled = (!isEnabled || isRestricted);
  const isTombstoned = (item.tombstoned) ? item.tombstoned : null;
  item.disabled = isDisabled; // For DnD

  const callbackPlay = useCallbackPlay(item);
  const playerLoadSong = (_pid) => (e) => {
    if (isEnabled && !isRestricted && !isTombstoned) {
      callbackPlay(_pid);
      e.stopPropagation(); // To avoid row selection
    }
  }

  // PREVIEW
  const previewPlayer = usePreviewPlayer(item.id, idParent, index);
  const isPreview = previewPlayer.isPreview;
  const stylePreview = (style) => ({
    ...style,
    // height: isPreview ? style.height + Config.GUTTER_PREVIEW : style.height,
  })

  // Automix
  const { loadToAutomix } = useAutomixLoad(item.id, enableActionsAutomix)

  // Cart
  const { addToCart, isInCart } = useCart(item);
  const { addToPlaylist, beginDnD } = useTracksToPlaylist([item], previewPlayer);
  const toStore = () => { if (item.toStore) { window.open(item.toStore, `_blank`); } }
  const { showContextMenu, showExtraMenu } = useRowAction(item.id, playerLoadSong, addToPlaylist, toStore, removeItem, isRestricted, loadToAutomix, (showCart && idParent !== 'collection') ? addToCart : null, isTombstoned); // TODO - REWORK

  return {
    isEnabled, isRestricted, isDisabled,
    playerLoadSong,
    previewPlayer, isPreview, stylePreview,
    beginDnD, showContextMenu, showExtraMenu,
    addToCart, isInCart,
    addToPlaylist,
    isTombstoned
  };
};

export default useTrackAccess;
